"use strict";

define('libs/filter_format/analyst',['underscore'], function (_) {
  var UNASSIGNED = 'Unassigned';
  var ANALYST_FIELD = 'analyst';
  var TASK_TYPE = 'taskType';
  var UNASSIGNED_ANALYST_TASK_TYPE = 'IRB_ANALYST_SELECTED';
  function analystFormatter(value, model, data) {
    var values = value.split(','),
      index = values.indexOf('Unassigned');
    if (index > -1) {
      values.splice(index, 1);
      data[ANALYST_FIELD] = values.join(',') || undefined;
      data[TASK_TYPE] = UNASSIGNED_ANALYST_TASK_TYPE;
    }
  }
  ;
  analystFormatter.UNASSIGNED = 'Unassigned';
  analystFormatter.ANALYST_FIELD = ANALYST_FIELD;
  return analystFormatter;
});

